import { createFileRoute } from "@tanstack/react-router";
import { GroupManagePage } from "@corpuscomplete/web/modules/auth/group/pages/group-manage";
import { GroupManage } from "@corpuscomplete/core-ui/auth/group/manage";

export const Route = createFileRoute("/_authenticated/groups/$id/manage")({
  component: GroupManagePage,
  loader: async ({ context, params }) => {
    if (context.zero) {
      GroupManage.preload(context.zero, params.id);
    }
  },
});
